export const GET_COUNTERPARTIES_LIST_REQUEST = 'GET_COUNTERPARTIES_LIST_REQUEST' as const;
export const GET_COUNTERPARTIES_LIST_SUCCESS = 'GET_COUNTERPARTIES_LIST_SUCCESS' as const;
export const GET_COUNTERPARTIES_LIST_ERROR = 'GET_COUNTERPARTIES_LIST_ERROR' as const;

export const GET_COUNTERPARTY_DETAILS_REQUEST = 'GET_COUNTERPARTY_DETAILS_REQUEST' as const;
export const GET_COUNTERPARTY_DETAILS_SUCCESS = 'GET_COUNTERPARTY_DETAILS_SUCCESS' as const;
export const GET_COUNTERPARTY_DETAILS_ERROR = 'GET_COUNTERPARTY_DETAILS_ERROR' as const;
export const CLEAR_COUNTERPARTY_DETAILS = 'CLEAR_COUNTERPARTY_DETAILS' as const;

export const POST_ADD_COUNTERPARTY_REQUEST = 'POST_ADD_COUNTERPARTY_REQUEST' as const;
export const POST_ADD_COUNTERPARTY_SUCCESS = 'POST_ADD_COUNTERPARTY_SUCCESS' as const;
export const POST_ADD_COUNTERPARTY_ERROR = 'POST_ADD_COUNTERPARTY_ERROR' as const;

export const PUT_UPDATE_COUNTERPARTY_REQUEST = 'PUT_UPDATE_COUNTERPARTY_REQUEST' as const;
export const PUT_UPDATE_COUNTERPARTY_SUCCESS = 'PUT_UPDATE_COUNTERPARTY_SUCCESS' as const;
export const PUT_UPDATE_COUNTERPARTY_ERROR = 'PUT_UPDATE_COUNTERPARTY_ERROR' as const;

export const DELETE_COUNTERPARTY_REQUEST = 'DELETE_COUNTERPARTY_REQUEST' as const;
export const DELETE_COUNTERPARTY_SUCCESS = 'DELETE_COUNTERPARTY_SUCCESS' as const;
export const DELETE_COUNTERPARTY_ERROR = 'DELETE_COUNTERPARTY_ERROR' as const;

export const CLOSE_ERROR_POPUP_COUNTERPARTY = 'CLOSE_ERROR_POPUP_COUNTERPARTY' as const;
export const CLOSE_ERROR_MODAL_COUNTERPARTY = 'CLOSE_ERROR_MODAL_COUNTERPARTY' as const;
